import {
    makeStyles,
} from 'app/tss'

const loggers = 'loggers'
const gateway = 'gateway'

const useStyles = makeStyles()((theme) => {
    return {
        gridWrapper: {
            display: 'grid',
            gap: theme.spacing(2.5),
            gridTemplateAreas: `"${loggers} ${loggers} ${loggers} ${gateway}"`,
            gridTemplateColumns: 'repeat(4, 1fr)',
        },
        loggers: {
            gridArea: loggers,
        },
        gateway: {
            gridArea: gateway,
        },
    }
})

export default useStyles
